import React from 'react';
import i18next from 'i18next';

import type { AppRouteGroup } from 'app/store/components/NavigationUtils';
import { lazyRetry } from 'app/main/components';

import en from './i18n/en';
import it from './i18n/it';

const Error401Page = lazyRetry(() => import('./Error401Page'));
const Error404Page = lazyRetry(() => import('./Error404Page'));
const Error500Page = lazyRetry(() => import('./Error500Page'));

i18next.addResourceBundle('en', 'core', en);
i18next.addResourceBundle('it', 'core', it);

const routes: AppRouteGroup = {
	settings: {},
	routes: [
		{
			path: '401',
			element: <Error401Page />
		},
		{
			path: '404',
			element: <Error404Page />
		},
		{
			path: '500',
			element: <Error500Page />
		}
	]
};

export default routes;
